export const ParticipantTrackType = {
	AUDIO: 0,
	VIDEO: 1,
	SCREENSHARE: 2,
} as const;
